// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","alertStatic":"_3YvHUNPH4LVsI2jOuAcy7X"};